import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;

export const SliderItem = styled.div<{ height?: number | string; padding?: number | string }>`
  background: #171a1c;
  border-radius: 8px;
  max-width: 100%;
  height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
  padding: ${({ padding }) => (typeof padding === 'string' ? padding : `${padding}px`)};
  &:focus-visible {
    border: none;
    outline: none;
  }
`;
SliderItem.defaultProps = {
  height: 200,
  padding: 0,
};

export const SliderThumbnail = styled.div<{ margin?: string | number; width?: string }>`
  margin: ${({ margin }) => margin};
  width: ${({ width }) => width};
`;

SliderThumbnail.defaultProps = {
  margin: `0`,
  width: 'auto',
};

export const SliderThumbnailItem = styled.div<{ thumbnailBorderWidth?: number }>`
  padding: ${({ thumbnailBorderWidth }) => `${thumbnailBorderWidth}px`};
  background: transparent;
  &:focus-visible {
    border: none;
    outline: none;
  }
`;

SliderThumbnailItem.defaultProps = {
  thumbnailBorderWidth: 1,
};

export const SliderThumbnailImage = styled.div<{
  src: string;
  active?: boolean;
  marginRight?: number | 0;
  thumbnailBorderWidth?: number;
}>`
  width: 52px;
  height: 52px;
  margin-right: ${({ marginRight }) => `${marginRight}px` || 0};
  outline: ${({ active, thumbnailBorderWidth }) =>
    active ? `${thumbnailBorderWidth}px solid white` : 'none'};
  background: ${({ src }) => `url(${src}) no-repeat center center`};
  background-size: contain;
  border-radius: 8px;
  cursor: pointer;
`;

SliderThumbnailImage.defaultProps = {
  active: false,
  marginRight: 10,
  thumbnailBorderWidth: 1,
};

export const SliderThumbnailIcon = styled.div<{
  active?: boolean;
  marginRight?: number | 0;
  thumbnailBorderWidth?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-right: ${({ marginRight }) => `${marginRight}px` || 0};
  outline: ${({ active, thumbnailBorderWidth }) =>
    active ? `${thumbnailBorderWidth}px solid white` : 'none'};
  background: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
`;

SliderThumbnailIcon.defaultProps = {
  active: false,
  marginRight: 10,
  thumbnailBorderWidth: 1,
};

export const SliderImage = styled.img`
  position: relative;
  margin: auto;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  object-fit: contain;
`;

export const GalleryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  z-index: 10;
  backdrop-filter: blur(2px);
  transition-duration: 0.5s;
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  &:focus {
    background-color: rgba(255, 255, 255, 0.2);
  }
  &:before {
    content: none;
  }
  @media (min-width: 481px) {
    width: 48px;
    height: 48px;
  }
  @media (max-width: 480px) {
    width: 36px;
    height: 36px;
  }
`;

export const SliderDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SliderDotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  background: transparent;
  cursor: pointer;
`;

export const SliderDot = styled.div<{ active: boolean }>`
  background-color: white;
  opacity: ${({ active }) => (active ? 1 : 0.4)};
  width: 5px;
  height: 5px;
  border-radius: 999rem;
`;
